/* eslint-disable @altermaind/you-shall-not-pass */
import { AccountStatus, QuestionType, Seniority } from '@/swagger/constants/surveys-enums';

export const MOCK_RESPONSE_GET_SURVEYS_CAMPAIGNS = [
  {
    id: '1',
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-01-01T00:00:00Z',
    organizationId: 'org-1',
    surveyTemplateId: 'template-1',
    templateVersion: 1,
    campaignName: 'Campaign 1',
    description: 'Description for Campaign 1',
    launchedAt: '2023-01-01T00:00:00Z',
    closedAt: '2023-01-01T00:00:00Z',
    invitedUserIds: ['user-1', 'user-2'],
    status: 'active',
  },
];

export const MOCK_RESPONSE_GET_SURVEY_CAMPAIGN_BY_ID = {
  id: '1',
  createdAt: '2023-01-01T00:00:00Z',
  updatedAt: '2023-01-01T00:00:00Z',
  organizationId: 'org-1',
  surveyTemplateId: 'template-1',
  templateVersion: 1,
  campaignName: 'Campaign 1',
  description: 'Description for Campaign 1',
  launchedAt: '2023-01-01T00:00:00Z',
  closedAt: '2023-01-01T00:00:00Z',
  invitedUserIds: ['user-1', 'user-2'],
  status: 'active',
};

export const MOCK_RESPONSE_POST_SURVEYS_CAMPAIGNS = undefined;

export const MOCK_RESPONSE_PUT_SURVEY_CAMPAIGN_BY_ID = {
  id: '1',
  createdAt: '2023-01-01T00:00:00Z',
  updatedAt: '2023-01-01T00:00:00Z',
  organizationId: 'org-1',
  surveyTemplateId: 'template-1',
  templateVersion: 1,
  campaignName: 'Campaign 1',
  description: 'Description for Campaign 1',
  launchedAt: '2023-01-01T00:00:00Z',
  closedAt: '2023-01-01T00:00:00Z',
  invitedUserIds: ['user-1', 'user-2'],
  status: 'active',
};

export const MOCK_RESPONSE_GET_TEMPLATES = [
  {
    id: '1',
    name: 'Soft Skills',
    isActive: true,
    metrics: [
      {
        id: 'metric-1',
        name: 'Net Promoter Score',
        description: 'Measures customer loyalty',
      },
    ],
    versions: [
      {
        version: 0,
        versionName: 'Edizione Aprile 2025',
        questions: [
          {
            id: 'q1',
            text: 'How satisfied are you with our service?',
            order: 1,
            type: QuestionType.SINGLE_CHOICE,
            isRequired: true,
            metricId: 'metric-1',
            options: [
              {
                id: 'opt1',
                text: 'Very Unsatisfied',
                metricScores: {
                  'metric-1': 1,
                },
              },
              {
                id: 'opt2',
                text: 'Unsatisfied',
                metricScores: {
                  'metric-1': 2,
                },
              },
              {
                id: 'opt3',
                text: 'Neutral',
                metricScores: {
                  'metric-1': 3,
                },
              },
              {
                id: 'opt4',
                text: 'Satisfied',
                metricScores: {
                  'metric-1': 4,
                },
              },
              {
                id: 'opt5',
                text: 'Very Satisfied',
                metricScores: {
                  'metric-1': 5,
                },
              },
            ],
            visibleTo: Seniority.JUNIOR,
          },
        ],
      },
    ],
  },
];

export const MOCK_RESPONSE_GET_TEMPLATE_BY_ID = {
  id: '1',
  name: 'Customer Satisfaction Survey',
  description: 'A survey to measure customer satisfaction',
  version: 1,
  isActive: true,
  createdAt: '2023-01-01T00:00:00Z',
  updatedAt: '2023-01-01T00:00:00Z',
  metrics: [
    {
      id: 'metric-1',
      name: 'Net Promoter Score',
      description: 'Measures customer loyalty',
      type: 'nps',
      scale: 10,
    },
  ],
  questions: [
    {
      id: 'q1',
      text: 'How satisfied are you with our service?',
      order: 1,
      type: QuestionType.SINGLE_CHOICE,
      isRequired: true,
      metricId: 'metric-1',
      options: [
        { id: 'opt1', text: 'Very Unsatisfied', order: 1 },
        { id: 'opt2', text: 'Unsatisfied', order: 2 },
        { id: 'opt3', text: 'Neutral', order: 3 },
        { id: 'opt4', text: 'Satisfied', order: 4 },
        { id: 'opt5', text: 'Very Satisfied', order: 5 },
      ],
      visibleTo: Seniority.SENIOR,
    },
  ],
};

export const MOCK_RESPONSE_GET_SURVEY_CAMPAIGN_INVITATION_BY_TEMPLATE_ID = {
  departments: [
    {
      name: 'Engineering',
      employees: [
        {
          email: 'emp1@example.com',
          firstName: 'Alice',
          lastName: 'Smith',
          status: AccountStatus.ENABLED,
          area: {
            id: 'software',
            name: 'Software',
          },
          department: {
            id: 'engineering',
            name: 'Engineering',
          },
          lastCompletedPeriod: 'senior',
        },
      ],
    },
  ],
};

export const MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_REMINDER = undefined;

export const MOCK_RESPONSE_GET_SURVEYS_CAMPAIGN_BY_ID_REMINDER_EMPLOYEES = {
  departments: [
    {
      name: 'Engineering',
      employees: [
        {
          email: 'emp1@example.com',
          firstName: 'Alice',
          lastName: 'Smith',
          status: AccountStatus.ENABLED,
          area: {
            id: 'software',
            name: 'Software',
          },
          department: {
            id: 'engineering',
            name: 'Engineering',
          },
          lastCompletedPeriod: 'senior',
        },
      ],
    },
    {
      name: 'Sales',
      employees: [
        {
          email: 'sales@example.com',
          firstName: 'Alice',
          lastName: 'Dohe',
          status: AccountStatus.ENABLED,
          area: {
            id: 'software',
            name: 'Software',
          },
          department: {
            id: 'sales',
            name: 'Sales',
          },
          lastCompletedPeriod: 'senior',
        },
      ],
    },
  ],
};

export const MOCK_RESPONSE_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_STATS = {
  totalInvitation: 0,
  completedSurveys: 10,
  totalCompletedEmployees: 100,
};

export const MOCK_RESPONSE_GET_SURVEY_CAMPAIGN_BY_ID_RESPONSES_RESULTS_STATS = {
  organizationStats: {
    totalInvited: 100,
    totalCompletedSurveys: 10,
    metricsScore: [
      {
        metric: {
          id: 'collaboration',
          name: 'Collaboration',
          description: 'Measures collaboration skills',
        },
        score: 5,
        beginningPercentage: 5,
        intermediatePercentage: 20,
        advancedPercentage: 75,
      },
      {
        metric: {
          id: 'problem-solving',
          name: 'Problem solving',
          description: 'Measures problem solving skills',
        },
        score: 7,
        beginningPercentage: 30,
        intermediatePercentage: 20,
        advancedPercentage: 50,
      },
      {
        metric: {
          id: 'execution-excellence',
          name: 'Execution Excellence',
          description: 'Measures execution excellence skills',
        },
        score: 7,
        beginningPercentage: 50,
        intermediatePercentage: 30,
        advancedPercentage: 20,
      },
      {
        metric: {
          id: 'learning-agility',
          name: 'Learning Agility',
          description: 'Measures learning agility skills',
        },
        score: 3,
        beginningPercentage: 90,
        intermediatePercentage: 5,
        advancedPercentage: 5,
      },
      {
        metric: {
          id: 'creativity',
          name: 'Creativity',
          description: 'Measures creativity skills',
        },
        score: 2,
        beginningPercentage: 5,
        intermediatePercentage: 70,
        advancedPercentage: 25,
      },
      {
        metric: {
          id: 'empathy',
          name: 'Empathy',
          description: 'Measures empathy skills',
        },
        score: 3,
        beginningPercentage: 30,
        intermediatePercentage: 30,
        advancedPercentage: 40,
      },
    ],
  },
  departmentsStats: [
    {
      totalCompletedSurveys: 10,
      totalInvited: 100,
      departmentId: 'engineering',
      departmentName: 'Engineering',
      metricsScore: [
        {
          metric: {
            id: 'collaboration',
            name: 'Collaboration',
            description: 'Measures collaboration skills',
          },
          score: 5,
          beginningPercentage: 5,
          intermediatePercentage: 20,
          advancedPercentage: 75,
        },
        {
          metric: {
            id: 'problem-solving',
            name: 'Problem solving',
            description: 'Measures problem solving skills',
          },
          score: 7,
          beginningPercentage: 30,
          intermediatePercentage: 20,
          advancedPercentage: 50,
        },
        {
          metric: {
            id: 'execution-excellence',
            name: 'Execution Excellence',
            description: 'Measures execution excellence skills',
          },
          score: 7,
          beginningPercentage: 50,
          intermediatePercentage: 30,
          advancedPercentage: 20,
        },
        {
          metric: {
            id: 'learning-agility',
            name: 'Learning Agility',
            description: 'Measures learning agility skills',
          },
          score: 3,
          beginningPercentage: 90,
          intermediatePercentage: 5,
          advancedPercentage: 5,
        },
        {
          metric: {
            id: 'creativity',
            name: 'Creativity',
            description: 'Measures creativity skills',
          },
          score: 2,
          beginningPercentage: 5,
          intermediatePercentage: 70,
          advancedPercentage: 25,
        },
        {
          metric: {
            id: 'empathy',
            name: 'Empathy',
            description: 'Measures empathy skills',
          },
          score: 3,
          beginningPercentage: 30,
          intermediatePercentage: 30,
          advancedPercentage: 40,
        },
      ],
    },
    {
      totalCompletedSurveys: 50,
      totalInvited: 90,
      departmentId: 'marketing',
      departmentName: 'Marketing',
      metricsScore: [
        {
          metric: {
            id: 'empathy',
            name: 'Empathy',
            description: 'Measures empathy skills',
          },
          score: 7,
          beginningPercentage: 40,
          intermediatePercentage: 40,
          advancedPercentage: 20,
        },
        {
          metric: {
            id: 'creativity',
            name: 'Creativity',
            description: 'Measures creativity skills',
          },
          score: 3,
          beginningPercentage: 10,
          intermediatePercentage: 10,
          advancedPercentage: 80,
        },
      ],
    },
  ],
};

export const MOCK_RESPONSE_GET_EMPLOYER_NOT_COMPLETED_SURVEYS = [
  {
    templateId: 'template-1',
    templateName: 'template-name',
    templateVersion: 1,
    campaignId: 'campaign-1',
  },
];

export const MOCK_RESPONSE_POST_EMPLOYER_BY_ID_SURVEY_RESULT = [
  {
    templateId: '68d11c9f9cfb224ef9670442',
    templateVersion: 1,
    templateName: 'Employee Experience Survey',
    completed: true,
    results: {
      id: '1',
      campaignId: '1',
      userId: '1',
      organizationId: 'org-1',
      surveyTemplateId: '1',
      templateVersion: 1,
      completedAt: '2023-10-10T10:00:00Z',
      answers: [],
      results: [
        {
          metric: {
            id: '1',
            name: 'Creativity',
            description: 'Description of Creativity',
          },
          score: 8,
        },
        {
          metric: {
            id: '2',
            name: 'Teamwork',
            description: 'Description of Teamwork',
          },
          score: 2,
        },
        {
          metric: {
            id: '3',
            name: 'Problem Solving',
            description: 'Description of Problem Solving',
          },
          score: 8,
        },
        {
          metric: {
            id: '4',
            name: 'Adaptability',
            description: 'Description of Adaptability',
          },
          score: 6,
        },
        {
          metric: {
            id: '5',
            name: 'Communication',
            description: 'Description of Communication',
          },
          score: 7,
        },
        {
          metric: {
            id: '6',
            name: 'Leadership',
            description: 'Description of Leadership',
          },
          score: 4,
        },
      ],
    },
  },
];

export const MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_NEXT = {
  isLast: false,
  nextQuestion: {
    id: 'q2',
    text: 'What can we improve?',
    isRequired: true,
    maxSelections: 1,
    type: QuestionType.SINGLE_CHOICE,
    options: [
      { id: 'opt1', text: 'Customer Support' },
      { id: 'opt2', text: 'Product Quality' },
      { id: 'opt3', text: 'Pricing' },
      { id: 'opt4', text: 'User Experience' },
    ],
    visibleTo: Seniority.MID,
  },
};

export const MOCK_RESPONSE_POST_SURVEYS_CAMPAIGN_BY_ID_END = undefined;

export const MOCK_RESPONSE_PUT_SURVEY_CAMPAIGN_VISIBILITY = undefined;

export const MOCK_RESPONSE_GET_SURVEY_CAMPAIGNS_RESULTS_STATS = [
  {
    campaignId: '1',
    surveyTemplateId: 'template-1',
    templateVersion: 1,
    launchedAt: '2023-01-01T00:00:00Z',
    closedAt: '2023-01-31T23:59:59Z',
    isVisible: true,
    stats: undefined,
  },
];

export const MOCK_RESPONSE_POST_TEMPLATE_SIMULATE = {
  results: [
    {
      metric: {
        id: 'metric-1',
        name: 'Collaboration',
        description: 'Measures collaboration skills',
      },
      score: 7.5,
    },
    {
      metric: {
        id: 'metric-2',
        name: 'Problem Solving',
        description: 'Measures problem solving skills',
      },
      score: 8.2,
    },
  ],
};
